// Разрешенные MIME типы
export const ALLOWED_MIME_TYPES = {
  images: [
    'image/jpeg',
    'image/jpg', 
    'image/png',
    'image/gif',
    'image/webp'
  ],
  audio: [
    'audio/mpeg',
    'audio/mp3',
    'audio/wav',
    'audio/ogg'
  ]
};

// Максимальные размеры файлов (в байтах)
export const MAX_FILE_SIZES = {
  images: 10 * 1024 * 1024, // 10MB
  audio: 50 * 1024 * 1024,  // 50MB (увеличено для компрессии)
};

// Функция проверки MIME типа
export const isValidMimeType = (file: File, type: 'images' | 'audio'): boolean => {
  return ALLOWED_MIME_TYPES[type].includes(file.type);
};

// Функция проверки размера файла
export const isValidFileSize = (file: File, type: 'images' | 'audio'): boolean => {
  return file.size <= MAX_FILE_SIZES[type];
};

// Основная функция валидации файла
export const validateFile = (file: File, type: 'images' | 'audio'): { 
  isValid: boolean; 
  error?: string; 
} => {
  // Проверяем MIME тип
  if (!isValidMimeType(file, type)) {
    return {
      isValid: false,
      error: `Неподдерживаемый тип файла: ${file.type}. Разрешены: ${ALLOWED_MIME_TYPES[type].join(', ')}`
    };
  }
  
  // Проверяем размер файла
  if (!isValidFileSize(file, type)) {
    const maxSizeMB = MAX_FILE_SIZES[type] / 1024 / 1024;
    return {
      isValid: false,
      error: `Файл слишком большой. Максимальный размер: ${maxSizeMB}MB`
    };
  }
  
  return { isValid: true };
};

// Функция для получения accept атрибута
export const getAcceptAttribute = (type: 'images' | 'audio'): string => {
  switch (type) {
    case 'images':
      return 'image/*';
    case 'audio':
      return 'audio/*,.mp3,.wav,.ogg';
    default:
      return '';
  }
}; 